<template>
  <common-dialog ref="dialog" width="90%" min-width="1100px" title="添加快递模板" id-key="id" :data="data" @opened="onOpened"
    :form-rules="rules" :before-save="onBeforeSave" :save-func="saveDataFunc" @closed="onClosed"
    @close-saved="$emit('close-saved')" close-on-saved>
    <template slot="form">
      <div class="box">
        <!-- <el-form-item label="电子面单账号店铺" prop="shopId" label-width="134px">
          <el-select v-model="mallToken" @change="onMallChange" placeholder="请选择">
            <el-option v-for="(i, k) in mallList" :key="k" :label="i.mallName" :value="i.token"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="快递公司" prop="aliLogisticId" label-width="100px">
          <el-select style="width: 240px;" v-model="data.aliLogisticId" placeholder="请选择" @change="onExpressChange">
            <el-option v-for="(i, k) in companiesList" :key="k" :label="i.companyName" :value="i.id"></el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="box">
        <div class="left" v-loading="tempLoading">
          <div class="left-item" :class="{ 'active': data.标准模板 == i.id }" v-for="(i, k) in templateList" :key="k"
            @click="onTempSelect(i)">
            <span>{{ i.name }}</span>
          </div>
        </div>
        <div class="center">
          <el-image
            src="https://cdn4.codesign.qq.com/prototypes/2024/03/22/Yyg5Z24px8Qo03Z2lKv22/fg0vjemgcicsecmr/4a220f1a2fe805a886c41fbfc6b73de6.png"
            fit="contain"></el-image>
        </div>
        <div class="right">
          <el-form-item label="模板名称" prop="模板名称" label-width="110px">
            <el-input v-model="data.模板名称" placeholder="请输入模板名称"></el-input>
          </el-form-item>
          <el-form-item label="网点发货地址" prop="网点发货地址" label-width="110px">
            <el-radio-group v-model="data.网点发货地址">
              <el-radio :label="i.id" v-for="(i, k) in 网点发货地址列表" :key="k" style="margin-top: 10px;line-height: 18px;">
                <div style="white-space: normal;display: table-cell;">
                  <span>{{ i.name }} 剩</span>
                  <span style="color: #d9001b;margin: 0 5px;">{{ i.number }}</span>
                  <span>单</span>
                </div>
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="增值服务" label-width="110px">
            <el-checkbox v-model="data.增值服务">圆准达</el-checkbox>
          </el-form-item>
          <el-form-item label="默认发货地址" prop="aliAddressId" label-width="110px">
            <el-select v-model="data.aliAddressId" placeholder="请选择" clearable>
              <el-option v-for="(i, k) in senderAddress" :key="k" :label="i.address" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
    </template>
    <template slot="footer">
      <el-button type="primary" @click="save">保 存</el-button>
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      aliApi: {
        logistics: require('@/api/ali/logistics').default,
      },
      sysType: "",
      mallToken: "", //店铺Token
      data: {
        id: 0,
        companiesName: "", //快递公司名称
        aliLogisticId: null, //快递公司
        aliAddressId: null,
        标准模板: null,
        模板名称: "",
        网点发货地址: null,
        增值服务: false,
      },
      mallList: [],
      companiesList: [],
      templateList: [],
      tempLoading: false,
      senderAddress: [],
      网点发货地址列表: [{
        id: 1,
        name: "浙江省金华市义乌市樊村46号楼5单元1楼",
        number: 9
      }, {
        id: 2,
        name: "上海市上海市闽行区七宝镇中春路7335号",
        number: 300
      }],
      rules: {
        aliLogisticId: [{ required: true, message: '请选择快递公司' }],
        aliAddressId: [{ required: true, message: '请选择默认发货地址' }],
        模板名称: [{ required: true, message: '模板名称不能为空' }],
        网点发货地址: [{ required: true, message: '请选择网点发货地址' }],
      },
    };
  },
  mounted() { },
  methods: {
    onOpened() {
      this.sysType = "ali"; //localStorage.getItem("sys_type");
      this.mallList = JSON.parse(localStorage.getItem("mall_list"));
      this.mallToken = localStorage.getItem("token");

      this.$refs.dialog.isLoading = true;
      var promises = [this.getCompanies(), this.getAddress()];
      Promise.all(promises).then(res => {
        this.$refs.dialog.isLoading = false;
        console.log('All promises succeeded: ', res);
        var errlist = res.filter(x => x.errorCode != undefined)
        if (errlist.length > 0) this.$message.error(errlist.join("\n"));
      }).catch(error => {
        console.log('All promises failed', error);
        this.$refs.dialog.isLoading = false;
      });
    },
    onMallChange() {
      this.companiesList = [];
      this.getCompanies();
    },
    getCompanies() {
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].logistics.getLogistics().then(res => {
          if (!res.errorCode) {
            console.log("sdfsdf")
            this.companiesList = res;
          }
          resolve(res);
        }).catch((err) => {
          reject(err)
        })
      })
    },
    getAddress() {
      return new Promise((resolve, reject) => {
        this[this.sysType + "Api"].logistics.getAddress().then(res => {
          if (!res.errorCode) {
            this.senderAddress = res.map(x => {
              return {
                ...x,
                address: x.fullAddress.replaceAll("^^^", "")
              }
            });
          }
          console.log("this.senderAddress", this.senderAddress)
          resolve(res);
        }).catch(err => {
          reject(err)
        })
      })
    },
    getTemplates(code) {
      return new Promise((resolve, reject) => {
        this.tempLoading = true;
        this.templateList = [];
        this[this.sysType + "Api"].logistics.standardtemplates(code).then(res => {
          this.tempLoading = false;
          if (!res.errorCode) {
            this.templateList = res.data.map(x => {
              return { id: x.id, name: x.standardTemplateName, url: x.standardTemplateUrl }
            });
          }
          resolve(res);
        }).catch((err) => {
          this.tempLoading = false;
          reject(err)
        })
      })
    },
    onExpressChange(data) {
      console.log("onExpressChange", data);
      // var item = this.companiesList.find(x => x.code == data);
      // this.data.companiesName = item.logisticsCompany;
      // this.data.模板名称 = "";
      // this.getTemplates(data);
    },
    onTempSelect(data) {
      console.log("onTempSelect", data)
      this.data.标准模板 = data.id;
      this.data.模板名称 = this.data.companiesName + "（" + data.name + "）";
    },
    onBeforeSave() {
      console.log("save", this.data);
      return false
    },
    saveDataFunc() {
      return new Promise((resolve, reject) => {
        resolve({ Code: 0, Msg: null });
      })
    },
    onClosed() {
      this.templateList = [];
      this.senderAddress = [];
      this.companiesList = [];
    }
  },
};
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  border: 1px solid #dedede;
  padding: 10px;

  .left {
    width: 260px;

    .left-item {
      height: 50px;
      border: 1px solid #dedede;
      // border-right: 3px solid #dedede;
      padding: 0 8px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .left-item+.left-item {
      border-top: none;
    }

    .active {
      background-color: #1890ff;
      border-color: #1890ff;
      // border-right: 3px solid #1890ff;
      color: #ffffff;
    }
  }

  .center {
    margin-left: 10px;
    width: 300px;

    .el-image {
      width: 100%;
      height: 100%;
    }
  }

  .right {
    margin-left: 10px;
    width: calc(100% - 580px);
  }
}

.box+.box {
  margin-top: 10px;
}
</style>